import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { url } from '../../helper/image';

export default class HeaderLayout extends Component {
    static propTypes = {
    };
  
    render() {
      return (
        <div className="header-front">
            <Link to='/'>
                <img className="logo-header" src={url("logo/logo-ynov-bx.svg")}/>
            </Link>
        </div>
      )
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/others/HeaderLayout.js